import CustomWallpaperUpsellCallouts from '@wetransfer/transfer/constant/flags/custom-wallpaper-upsell-callouts';

export const useOptionsCustomWallpaperUpsellPopover = (): {
  isVisible: boolean;
} => {
  // TODO: popover visibility logic will be added here in a separate PR
  return {
    isVisible: CustomWallpaperUpsellCallouts.isOn() && false,
  };
};
